import { useLocation, useNavigate } from "react-router-dom";

export default function Success() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Robust orderId retrieval
  const orderId =
    location.state?.orderId ||
    sessionStorage.getItem("lastOrderId") ||
    "—";

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Success Icon */}
        <div style={styles.icon}>✅</div>

        {/* Title */}
        <h2 style={styles.title}>Order Placed!</h2>

        {/* Subtitle */}
        <p style={styles.text}>
          Thank you for shopping with <strong>Eyal Mart</strong>
        </p>

        {/* Order ID */}
        <div style={styles.orderBox}>
          <span style={styles.label}>Order ID</span>
          <div style={styles.orderId}>{orderId}</div>
        </div>

        {/* CTA */}
        <button
          style={styles.btn}
          onClick={() => {
            sessionStorage.removeItem("lastOrderId"); // cleanup
            navigate("/allproducts");
          }}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}

/* ===============================
   STYLES
================================ */
const styles = {
  page: {
    height: "100dvh",
    background: "#f9fafb",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "#ffffff",
    borderRadius: 16,
    padding: 24,
    textAlign: "center",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
  },
  icon: {
    fontSize: 46,
    marginBottom: 12,
  },
  title: {
    marginBottom: 6,
    fontSize: 22,
    fontWeight: 700,
  },
  text: {
    color: "#6b7280",
    fontSize: 14,
    marginBottom: 18,
  },
  orderBox: {
    background: "#f1f5f9",
    borderRadius: 12,
    padding: 14,
    marginBottom: 20,
  },
  label: {
    fontSize: 12,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
  },
  orderId: {
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: 0.4,
  },
  btn: {
    width: "100%",
    height: 46,
    borderRadius: 12,
    border: "none",
    background: "#2563eb",
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
  },
};
